import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Button, ButtonState, ButtonType, Column, FormBuilder, FormField, Icon, IconColor, IconName, Input, InputState, InputType, Label, LabelSize, Row, } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import FormValidationUtil from '../../../util/FormValidationUtil';
import { Box } from '@yonderland/andes-react';
export var BasketSaveFormState;
(function (BasketSaveFormState) {
    BasketSaveFormState["INPUT"] = "input";
    BasketSaveFormState["SUBMITTING"] = "submitting";
    BasketSaveFormState["COMPLETE"] = "complete";
})(BasketSaveFormState || (BasketSaveFormState = {}));
const initialValues = {
    email: '',
};
export const BasketSaveForm = ({ onSubmit, state = BasketSaveFormState.INPUT, isHorizontal, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.checkout, I18N_NAMESPACES.form]);
    const handleValidation = (values) => {
        const errors = {};
        if (!values.email) {
            errors.email = t(`${I18N_NAMESPACES.checkout}:checkout.required`);
        }
        else if (!FormValidationUtil.isValidEmailPattern(values.email)) {
            errors.email = t(`${I18N_NAMESPACES.checkout}:checkout.patternMail`);
        }
        return errors;
    };
    return (_jsx(FormBuilder, { initialValues: initialValues, validate: handleValidation, validateOnBlur: false, onSubmit: onSubmit, name: "basket-save-form", children: ({ errors, touched }) => (_jsxs(Row, { parent: true, children: [_jsxs(Column, { noGutterLeft: true, noGutterRight: !isHorizontal, grid: isHorizontal ? 8 : 12, children: [_jsx(Label, { required: true, size: LabelSize.MINOR, emphasized: true, htmlFor: "basket-save-email", children: t(`${I18N_NAMESPACES.form}:form.email`) }), _jsx(FormField, { type: InputType.EMAIL, id: "basket-save-email", name: "email", required: true, state: errors.email && touched.email && InputState.ERROR, placeholder: t(`${I18N_NAMESPACES.form}:form.email`), adornmentEnd: errors.email &&
                                touched.email && _jsx(Icon, { name: IconName.EXCLAMATION_CIRCLE_SOLID, color: IconColor.NEGATIVE }), Component: Input, readOnly: state !== BasketSaveFormState.INPUT })] }), _jsx(Column, { noGutterRight: true, noGutterLeft: !isHorizontal, grid: isHorizontal ? 4 : 12, children: _jsx(Box, { paddingBlockStart: !isHorizontal ? '4' : '6', children: _jsx(Button, { text: t(`${I18N_NAMESPACES.form}:form.send`), iconRight: { name: IconName.CHEVRON_RIGHT }, type: ButtonType.SUBMIT, state: state === BasketSaveFormState.SUBMITTING
                                ? ButtonState.LOADING
                                : state === BasketSaveFormState.COMPLETE
                                    ? ButtonState.FINISHED
                                    : null, finisher: {
                                icon: IconName.CHECK,
                                text: t(`${I18N_NAMESPACES.form}:form.sent`),
                            }, fill: true }) }) })] })) }));
};
